export default __webpack_public_path__ + "static/media/certification-wig-fr.ab93f94a.jpeg";